import type { Container } from 'inversify';
import {
	IAdminService,
	ICategoryService,
	IEmailAuthService,
	IDailyWordTrackingService,
	IMnemonicService,
	IMnemonicLikeService,
	INewsContentService,
	IPremiumTrackingService,
	IQuizzService,
	ISyncApiService,
	ITelegramEmailConnectionService,
	IUserFsrsCardService,
	IUserMetadataService,
	IUserPreferencesService,
} from '@lingvo-news/contracts';
import { createClient } from './runtime-service-client';

export function bindHttpServiceClients(container: Container, baseUrl: string): void {
	const bind = <TService>(svc: Function): void => {
		if (!container.isBound(svc as never)) {
			container.bind(svc as never).toDynamicValue(() => createClient<TService>(svc, { baseUrl }) as never).inSingletonScope();
		}
	};

	bind<IUserPreferencesService>(IUserPreferencesService);
	bind<ISyncApiService>(ISyncApiService);
	bind<INewsContentService>(INewsContentService);
	bind<IMnemonicService>(IMnemonicService);
	bind<IUserFsrsCardService>(IUserFsrsCardService);
	bind<IQuizzService>(IQuizzService);
	bind<ICategoryService>(ICategoryService);
	bind<IAdminService>(IAdminService);
	bind<IEmailAuthService>(IEmailAuthService);
	bind<IPremiumTrackingService>(IPremiumTrackingService);
	bind<ITelegramEmailConnectionService>(ITelegramEmailConnectionService);
	bind<IDailyWordTrackingService>(IDailyWordTrackingService);
	bind<IMnemonicLikeService>(IMnemonicLikeService);
	bind<IUserMetadataService>(IUserMetadataService);
}

